import { IThemeInterface } from './types'

export const mgInvestments: IThemeInterface = {
  brand: {
    rgb: {
      primary: 'var(--color-primary)',
      secondary: 'var(--color-secondary)',
      warning: 'var(--color-warning)',
      info: 'var(--color-info)',
      success: 'var(--color-success)',
      danger: 'var(--color-danger)',
      dark: 'var(--text-heading)',
      light: 'var(--surface-bg)'
    }
  },
  colors: {
    violet: '#7b76b6',
    lightpink: '#e58ebb',
    petrol: '#0097a9',
    yellow: '#ffb81c',
    coral: '#eb5c37',
    grey: '#5b656e',
    lightcoral: '#e98276',
    jade: '#17b0ad'
  },
  font: {
    SMALLEST: '0.4rem',
    SMALLER: '0.6rem',
    SMALL: '0.8rem',
    MEDIUM: '1rem',
    LARGE: '1.2rem',
    LARGER: '1.4rem',
    LARGEST: '1.6rem'
  },
  components: {
    highlighter: 'var(--color-warning)'
  }
}
